module.exports = __webpack_public_path__ + "static/media/photo-2.aaa8c5e4.avif";